import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { func, string } from 'prop-types';

import { clearErrorMessage } from '../../features/App/reducer';
import SCErrorBox from './styles';
import {Button} from '../Buttons';

ErrorPopup.propTypes = {
  clearErrorMessage: func.isRequired,
  errorMsg: string.isRequired,
};

function ErrorPopup(props) {
  return (
    <SCErrorBox errorMsg={props.errorMsg}>
      <p>
        Fel: {props.errorMsg}
        <br />
        Testa att ladda om sidan. Kontakta support om problemet kvarstår.
      </p>
      <Button big raised onClick={props.clearErrorMessage}>
        Stäng
      </Button>
    </SCErrorBox>
  );
}

const mapStateToProps = state => ({
  errorMsg: state.application.error,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearErrorMessage,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPopup);



// WEBPACK FOOTER //
// ./src/components/ErrorPopup/ErrorPopup.js